import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/editor/dropdown-menu';
import { Button } from '@/components/form/Button';
import { buttonClassName } from '@/components/form/buttonHelper';
import { Property } from '@/components/form/fields/select/SelectInput';
import { Card } from '@/components/sections/Card';
import SiChevronDown from '@/icons/SiChevronDown';
import { cn } from '@/lib/utils';
import { FC, useState } from 'react';

interface AssociationProps {
  incoming: string;
  options: Property[];
  mapping?: string;

  onCreate?: (incoming: string) => Promise<void>;
  onAssociate: (incoming: string, choice: Property) => void;
}

export const Association: FC<AssociationProps> = ({ incoming, options, onAssociate, onCreate, mapping }) => {
  const [loading, setIsLoading] = useState(false);
  return (
    <Card className="flex items-center justify-between p-4">
      <p>{incoming}</p>
      {!mapping ? (
        <div className="flex justify-between gap-2">
          {onCreate && (
            <Button
              loading={loading}
              onClick={async () => {
                setIsLoading(true);
                await onCreate(incoming);
                setIsLoading(false);
              }}
            >
              Create
            </Button>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className={cn(buttonClassName(), 'cursor-pointer')}>
                Associate
                <SiChevronDown />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuGroup>
                {options.map(({ id, name }) => (
                  <DropdownMenuItem
                    key={id}
                    className="text-secondary-std px-1.5 py-4"
                    onClick={() => onAssociate(incoming, { id, name })}
                  >
                    <span>{name}</span>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      ) : (
        <div>{options.find(option => option.id === mapping)?.name}</div>
      )}
    </Card>
  );
};
